import { Link } from 'react-router-dom'
import { ROUTES } from '@/constants'

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t py-8 text-sm text-muted-foreground">
      <div className="container mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 sm:flex-row sm:justify-between">
        <div className="flex items-center gap-2">
          {/* add image from public folder */}
          <img src="images/logo/logo.png" alt="UnsplashKH Logo" className="h-10 w-25" />
          <span>· © {year}</span>
        </div>

        <nav aria-label="Footer navigation">
          <ul className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <li><Link to={ROUTES.HOME} className="hover:text-foreground transition-colors">Home</Link></li>
            <li><Link to={ROUTES.EXPLORE} className="hover:text-foreground transition-colors">Explore</Link></li>
            <li><Link to={ROUTES.UPLOAD} className="hover:text-foreground transition-colors">Upload</Link></li>
            <li><Link to={ROUTES.ABOUT} className="hover:text-foreground transition-colors">About</Link></li>
          </ul>
        </nav>
      </div>
    </footer>
  )
}
